import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    maxWidth: 350,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '50vw',
      height: '45vw',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  profileImage: {
    width: '60%',
    height: '60%'
  }
}))

export default useStyles
